export default {
  "已有账号？": "アカウントを持っていますか？",
  "去登录": "ログイン",
  "首次登录，请选择语言": "初回ログイン、言語を選択してください",
  "立即切换": "今すぐ切り替える",
    "投注": "賭け",
    "请先绑定银行卡": "銀行カード連携",
    "服务评分": "サービス評価",
    "历史": "履歴",
    "绑定上限，请联系客服!": "上限到達、サポートへ!",
    "已达绑定上限": "連携上限に達しました",
    "任务详情": "タスク詳細",
    "投票详情": "投票詳細",
    "获得金额": "獲得金額",
    "待结算": "決済待ち",
    "再来一次": "もう一度",
    "时间": "時間",
    "备注": "備考",

    accountDetailTab: {
        "充值": 'チャージ',
        "提现": '引き出し',
        "投票": '投票详情',
    },
    "选择{name}": "{name}を選択",
    "个人简介": "個人プロフィール",
    "投票金额": "投票金額",
    "投票记录": "投票履歴",
    "投票方向": "投票方向",
    "下注金额": "賭け金額",
    "投票": "投票",
    "确认投票": "投票を確認",
    "银行账户号码": "銀行口座番号",
    "提现到": "引き出し先",
    "去绑定": "今すぐ紐付ける",
    "信誉分": "信用スコア",
    "取款方式": "出金方法",

    "立即预约": "今すぐ予約",
    "住所": "住所",
    "照片": "写真",
    "胸围": "バスト",
    "约炮推荐": "出会い推奨",
    "高端专区": "高級ゾーン",
    "暂无信息": "情報なし",
    "观影券": "映画チケット",
    "观影券不足": "映画チケット不足",
    "详情信息": "詳細情報",
    "银行卡": "銀行カード",
    "x次认证": "{num}回認証済み",
    "请输入您的收款卡信": "お支払いカード情報を入力してください",
    "绑定银行卡": "銀行カードを紐付ける",
    "绑定USDT地址": "USDTアドレスを紐付ける",
    "请选择{name}": "{name}を選択してください",
    "请输入{name}": "{name}を入力してください",
    "银行地址": "銀行住所",
    "银行账户": "銀行口座",
    "ABA/路由代码": "ABA/ルーティングコード",
    "SWIFT代码": "SWIFTコード",
    "姓名": "名前",
    "虚拟币": "仮想通貨",
    "币种": "通貨",
    "地址": "アドレス",
    "确认绑定": "紐付けを確認",
    "银行列表": "銀行リスト",
    "暂无数据": "データなし",
    "充值": "チャージ",
    "旧密码": "旧パス",
    "新密码": "新パス",
    "请输入您的旧密码": "旧パスを入力",
    "请输入您的新密码": "新パスを入力",
    "请再次输入您的新密码": "再入力",
    "修改登录密码": "パス変更",
    "收款卡信息": "カード情報",
    "投票结果": "結果",

    tabbar: {
        "首页": "ホーム",
        "预约": "予約",
        "地区选择": "地域",
        "视频": "動画",
        "我的": "マイ"
    },
    "高端": "高級",
    "认证": "認証",
    "视频认证": "ビデオ認証",
    "收费区间": "料金範囲",
    "身高": "身長",
    "胸圍": "バスト",
    "服務城市": "サービス都市",
    "全國空降": "全国派遣",
    "是": "はい",
    "否": "いいえ",
    "我要约她": "予約する",
    "城市大全": "都市リスト",
    "流程价格": "手順価格",
    "刷新成功": "更新成功",
    "预约大厅": "予約ホール",
    "全部": "すべて",
    "查看更多": "もっと見る",
    "推荐任务": "おすすめ任務",
    "人气排行": "人気ランキング",
    "热门推荐": "人気おすすめ",
    "获取中": "取得中",
    "语言": "言語",
    "登录": "ログイン",
    "忘记密码": "パスワード忘れた",
    "没有账户？马上注册": "アカウントがない？登録する",
    "请输入用户名": "ユーザー名を入力",
    "请输入密码": "パスワードを入力",
    "注册": "登録",
    "我已经知晓并同意'开户协议'各项条约": "規約に同意します",
    "请输入邀请码": "招待コードを入力",
    "请输入用户名({min}-{max}个英文字母或数字)": "ユーザー名（{min}-{max}文字）",
    "请输入登录密码({min}-{max}个英文字母或数字)": "パスワード（{min}-{max}文字）",
    "请勾选下方开户协议": "規約にチェック",
    "可用余额": "残高",
    "元": "元",
    "提交": "送信",
    "当前选号": "現在選択",
    "每注金额": "1件あたり",
    "请输入金额": "金額を入力",
    "总共": "合計",
    "注": "件",
    "合计": "総計",
    "任务单": "任務表",
    "1注X{money}元={money}元": "1件X{money}={money}",
    "清空订单": "クリア",
    "确认提交": "送信確認",
    "期号": "期番号",
    "第{x}期": "第{x}期",
    "数据": "データ",
    "双": "偶数",
    "单": "奇数",
    "未选择": "未選択",
    "金额错误": "金額エラー",
    "请选号": "番号選択",
    "请填写金额": "金額を記入",
    "余额不足，请联系客服充值！": "残高不足、サポートに連絡！",
    "未选中": "未選択",
    "请联系管理员领取该任务": "管理者に連絡",
    "开奖成功，期号：": "抽選成功、期番号：",
    "大": "大",
    "小": "小",
    "填写收款卡": "カード情報記入",
    "请输入您的收款卡信息": "カード情報入力",
    "银行卡号": "カード番号",
    "请输入真实银行卡号": "正しい番号入力",
    "银行名称": "銀行名",
    "请选择银行": "銀行選択",
    "尊敬的用户,为了保障您的资金安全,请您绑定您的真实姓名和设置取款密码,如果姓名与开户名不一致,将无法取款": "安全のため本名とパスワード設定",
    "确认绑卡": "カード確認",
    "请输入银行卡号": "番号入力",
    "任务记录": "任務記録",
    "任务记录Title": "任務記録",
    "数据为空": "データなし",
    "下单时间": "注文時間",
    "结算时间": "精算時間",
    "提现": "引き出し",
    "我的钱包": "マイウォレット",
    "详情": "詳細",
    "余额": "残高",
    "个人报表": "個人報告",
    "账户明细": "口座明細",
    "个人中心": "マイページ",
    "信息公告": "お知らせ",
    "在线客服": "サポート",
    "请完成任务单后进入": "任務完了後に進む",
    "请联系客服充值": "サポート連絡",
    "请设置收款卡": "カード設定",
    "功能已禁用": "機能無効",
    "账号下线": "アカウントオフ",
    "登录/注册": "ログイン/登録",
    "登录可享受更多服务": "ログインで利用可能",
    "基本信息": "基本情報",
    "头像": "アイコン",
    "选择头像": "アイコン選択",
    "确定": "確認",
    "取消": "キャンセル",
    "真实姓名": "本名",
    "未设置": "未設定",
    "性别": "性別",
    "绑定信息": "バインド情報",
    "已绑定": "バインド済み",
    "无": "なし",
    "男": "男性",
    "女": "女性",
    "未知": "不明",
    "系统公告": "システム通知",
    "盈利金额": "利益金額",
    "盈利计算公式 : 中奖金额 - 任务金额": "利益 = 当選金額 - 任務金額",
    "任务金额": "任務金額",
    "充值金额": "チャージ金額",
    "提现金额": "引き出し金額",
    "中奖金额": "当選金額",
    "客服": "サポート",
    "蜜獾娱乐": "ハニーバジャー",
    "联系": "連絡",
    "全天7 * 24小时竭诚为您服务": "24時間サポート",
    "添加收款卡": "カード追加",
    "提示:请绑定大型商业银行,如需修改,请您联系在线客服": "ヒント：大手銀行を使用",
    "修改真实姓名": "本名変更",
    "保存": "保存",
    "请输入真实姓名": "本名入力",
    "为了您账户安全,真实姓名需要与绑定银行卡姓名一致": "名前一致必須",
    "请勿重复设置": "再設定不可",
    "请输入姓名": "名前を入力",
    "请输入资金密码": "パスワード入力",
    "设置资金密码": "パスワード設定",
    "请再次输入资金密码": "再度入力",
    "请填写完整": "完全記入",
    "两次密码不一致": "パスワード不一致",
    "性别修改": "性別変更",
    "设置": "設定",
    "基本信息设置": "基本設定",
    "登录密码": "ログインパス",
    "资金密码": "資金パス",
    "退出登录": "ログアウト",
    "已设置": "設定済み",
    "提现密码已设置，需要修改请联系客服": "変更：サポート連絡",
    "提现中心": "引き出しセンター",
    "提现记录": "引き出し履歴",
    "1.单笔限额：最低{min}元，最高{max}元": "1. 限額: {min}-{max}",
    "2.提现次数：一天最高提现{num}次": "2. 最大{num}回/日",
    "3.到账时间": "3. 時間: 平均15分、最遅2時間",
    "限额说明": "限額説明",
    "马上提现": "今すぐ引き出し",
    "请填写正确的金额": "正しい金額を入力",
    "金额": "金額",
    "说明": "説明",
    "提交时间": "提出時間",
    "审核时间": "審査時間",
    "视频影院": "ビデオシアター",
    "没有更多了": "以上なし",
    "播放": "再生",
    "x播放": "x再生",
    "首页": "ホーム",
    "选妃": "選ぶ",
    "选妃列表": "リスト",
    "选妃详情": "詳細",
    "语言选择": "言語選択",
    "我的": "マイ",
    "视频": "ビデオ",
    "游戏": "ゲーム",
    "修改性别": "性別変更",
    "支付密码管理": "支払管理",
    "登录密码管理": "ログイン管理",
    "详情页面": "詳細ページ",
    "视频播放": "ビデオ再生",

    "本期":"今期",
    "剩余时间":"残り時間",
    "立即投票":"今すぐ投票",
    "提前预订卡进度":"事前予約カード進捗",

    "预订状态":"予約状況",

}
   